<template>
  <section
    class="flex flex-col rounded-md border border-light-gray p-4 text-left"
  >
    <h1 class="text-dark-blue">Credit Approval</h1>
    <p class="mt-2 text-xs text-body-color">
      Credit Approval is provided by Triumph.**
    </p>
    <div
      class="mt-4 flex h-full flex-col items-center justify-center gap-3 p-4"
      :class="statusClass"
      style="min-height: 172px"
    >
      <div class="flex flex-col items-center">
        <div
          class="flex items-center gap-2"
          :class="{ 'mt-3': creditStatusText == 'Unknown' }"
        >
          <h1
            :class="[
              creditStatusText == 'Unknown'
                ? 'text-body-color'
                : 'text-dark-blue',
            ]"
            class="text-base"
          >
            {{ creditStatusText }}
          </h1>
          <svg
            v-if="creditApproval === 'approved'"
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.5 14.8906C11.366 14.8906 14.5 11.7566 14.5 7.89063C14.5 6.77283 14.238 5.71623 13.7721 4.77888L7.74412 10.8068L7.03701 11.5139L6.3299 10.8068L3.24992 7.72684L4.66414 6.31263L7.03701 8.6855L12.6129 3.10958C11.3355 1.74406 9.51742 0.890625 7.5 0.890625C3.63401 0.890625 0.5 4.02463 0.5 7.89063C0.5 11.7566 3.63401 14.8906 7.5 14.8906Z"
              fill="#54C774"
            />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14 7.39062C14 11.2566 10.866 14.3906 7 14.3906C3.13401 14.3906 0 11.2566 0 7.39062C0 3.52463 3.13401 0.390625 7 0.390625C10.866 0.390625 14 3.52463 14 7.39062ZM7.0595 2.52351C7.95291 2.47575 8.83717 2.7773 9.41463 3.52435C9.93112 4.19252 9.92621 4.95515 9.75864 5.55618C9.5962 6.1388 9.26307 6.66291 8.9475 7.05733L8.40562 7.7346C8.14305 8.06278 8 8.47056 8 8.89085H6C6 8.01638 6.29764 7.16795 6.84395 6.48513L7.38583 5.80785C7.6097 5.52804 7.76901 5.24541 7.83212 5.01904C7.88813 4.81813 7.84687 4.76598 7.83356 4.74915L7.83227 4.74751C7.73732 4.62468 7.54762 4.50027 7.16628 4.52066C6.77252 4.54172 6.22037 4.72535 5.59999 5.19062L4.40001 3.59061C5.25515 2.94927 6.17852 2.57062 7.0595 2.52351ZM5.99992 10.1363V12.3495H7.99992V10.1363H5.99992Z"
              fill="#A9ADBD"
            />
          </svg>
        </div>
        <p
          v-if="creditStatusText === 'Unknown'"
          class="text-left text-3xs text-gray-over-dark"
        >
          <a
            class="cursor-pointer underline hover:opacity-80"
            href="https://www.invoicefactoring.com/rp-freight-factoring/?CampaignID=7010H000001n4DKQAY&AccountID=0016S00003jtEHHQA2&AccountOwner=005i0000001NKACAA4&utm_campaign=0016S00003jtEHHQA2&utm_source=rp&utm_campaign=Highway%20Carrier%20Portal&utm_source=Highway%20App&utm_medium=Carrier%20Portal&utm_term=Triumph&utm_content=Referral"
            target="_blank"
            >Learn more</a
          >
          about factoring with Triumph.
        </p>
      </div>
    </div>
    <p
      v-if="creditStatusText !== 'Unknown'"
      class="-mb-1 pt-3 text-left text-3xs text-gray-over-dark"
    >
      <a
        class="cursor-pointer underline hover:opacity-80"
        href="https://www.invoicefactoring.com/rp-freight-factoring/?CampaignID=7010H000001n4DKQAY&AccountID=0016S00003jtEHHQA2&AccountOwner=005i0000001NKACAA4&utm_campaign=0016S00003jtEHHQA2&utm_source=rp&utm_campaign=Highway%20Carrier%20Portal&utm_source=Highway%20App&utm_medium=Carrier%20Portal&utm_term=Triumph&utm_content=Referral"
        target="_blank"
        >Learn more</a
      >
      about factoring with Triumph.
    </p>
  </section>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  creditApproval: {
    type: String,
    required: true,
    default: 'unknown',
  },
});

const statusStyles = {
  approved: {
    borderClass: 'border-green-500',
    bgClass: 'bg-green-100',
    textClass: 'text-green-500',
    limit: 'Up to $50,000',
    statusText: 'Approved',
  },
  unknown: {
    borderClass: 'border-light-gray',
    bgClass: 'bg-off-white',
    textClass: 'text-body-color',
    limit: 'Pending Approval',
    statusText: 'Unknown',
  },
};

const currentStyles = computed(
  () => statusStyles[props.creditApproval] || statusStyles['unknown']
);

const statusClass = computed(() => [
  'border rounded-md',
  currentStyles.value.borderClass,
  currentStyles.value.bgClass,
]);

const creditStatusText = computed(() => currentStyles.value.statusText);
</script>

<style scoped>
.icon {
  width: 15px;
  height: 15px;
}
</style>
